"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionEventListenerRegistrationRequest = void 0;
/**
 * Data type for a SESSION_EVENT_REGISTRATION request.
 */
var SessionEventListenerRegistrationRequest = /** @class */ (function () {
    /**
     * Create a new SessionEventListenerRegistrationRequest instance
     *
     * @param filter  the filter
     * @param overwriteProperties  the properties to modify
     * @param removeProperties  the properties to remove
     */
    function SessionEventListenerRegistrationRequest(isClusterAware, sessionFilter, requestedProperties, sessionStartTime, conversationId) {
        this.isClusterAware = isClusterAware;
        this.sessionFilter = sessionFilter;
        this.requestedProperties = requestedProperties;
        this.sessionStartTime = sessionStartTime;
        this.conversationId = conversationId;
    }
    return SessionEventListenerRegistrationRequest;
}());
exports.SessionEventListenerRegistrationRequest = SessionEventListenerRegistrationRequest;
